// Module
var code = "<div class=\"ecv-separator form-group schema-form-{{form.type}} {{form.htmlClass}}\" ng-style=\"{{ form.style }}\"> </div> ";
// Exports
var _module_exports = code;;
var path = 'app/common/schemaFormUtility/components/addons/templates/ecv-separator.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;